import { AppKey, SimpleApp } from '../../../../libs/apps';
import { CheckboxGroupProps } from 'blueprint-form';

interface AppsAndOptions {
  selectedApps: SimpleApp[];
  options: CheckboxGroupProps['options'];
}

export function sortApps(appA: SimpleApp, appB: SimpleApp): number {
  const keyA = appA.key;
  const keyB = appB.key;

  if (keyA < keyB) return -1;
  if (keyA > keyB) return 1;
  return 0;
}

export function pairAppsWithKeys(
  appKeys: AppKey[],
  apps: Record<AppKey, SimpleApp>
): AppsAndOptions {
  if (!apps) {
    return {
      selectedApps: [],
      options: []
    };
  }
  if (!appKeys || !appKeys.length) {
    const options = Object.values(apps)
      .filter((app) => app.key !== 'composer')
      .sort(sortApps)
      .slice(0, 5)
      .map((app) => {
        return {
          value: app.key,
          label: app.name
        };
      });
    return {
      selectedApps: [],
      options
    };
  }
  const selectedApps = appKeys
    .map((key) => apps[key])
    .filter((app) => app != null && app.key !== 'composer');
  const options = selectedApps.sort(sortApps).map((app) => {
    return {
      value: app.key,
      label: app.name
    };
  });
  return {
    selectedApps,
    options
  };
}
